import { useEffect, useState } from 'react';
import scriptLoader from '@helpers/scriptLoader';
import { useAppSelector } from '@redux/hooks';
import { getUserProfileData } from '@entities/User';
import { getRecordService } from '@entities/Services';
import { getUserDiscountCards } from '@entities/Discount';
import { getListOx } from '@entities/Storage';
import { getUserAutoList } from '@entities/Auto';
import { getListsOrder } from '@entities/Order';
import { useJivoSiteHandlers } from '@features/jivoSite/module/hooks/useJivoSiteHandlers';

export const useInitJivoSite = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const user = useAppSelector(getUserProfileData);
  const record = useAppSelector(getRecordService);
  const card = useAppSelector(getUserDiscountCards);
  const ox = useAppSelector(getListOx);
  const cars = useAppSelector(getUserAutoList);
  const orders = useAppSelector(getListsOrder);

  const { handlerSendUserData } = useJivoSiteHandlers();

  useEffect(() => {
    scriptLoader({
      defer: true,
      async: true,
      delay: 1000,
      src: '//code-ya.jivosite.com/widget/ETFjL1bWzD',
      onload: () => {
        console.log('@loaded jivosite');
        window.jivo_onOpen = () => {
          handlerSendUserData();
          _tmr.push({ type: 'reachGoal', id: 3239286, goal: 'vbi_jivo_init' });
        };
        setIsLoaded(true);
      },
    });
  }, []);

  useEffect(() => {
    if (isLoaded) {
      window.jivo_onOpen = () => {
        handlerSendUserData();
        _tmr.push({ type: 'reachGoal', id: 3239286, goal: 'vbi_jivo_init' });
      };
    }
  }, [isLoaded, user, record, card, ox, cars, orders]);
};
